/**
 * Shared layout for static legal pages (Mentions légales, CGV, Confidentialité).
 * Renders a consistent document chrome around the markdown-like content.
 */
export default function LegalPage({ title, subtitle, lastUpdate, children, testid }) {
  return (
    <article className="max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-28" data-testid={testid}>
      <header className="mb-12 border-b border-border pb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-primary mb-3">· Document légal ·</div>
        <h1 className="font-display text-4xl sm:text-5xl">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-3 max-w-2xl">{subtitle}</p>}
        {lastUpdate && (
          <div className="text-xs text-muted-foreground mt-4 italic">Dernière mise à jour : {lastUpdate}</div>
        )}
      </header>
      <div className="prose prose-invert max-w-none text-muted-foreground leading-relaxed [&_h2]:text-foreground [&_h2]:font-display [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:text-foreground [&_h3]:font-medium [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_a]:text-primary [&_strong]:text-foreground [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-3 [&_p]:my-3">
        {children}
      </div>
    </article>
  );
}
